let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("ap7kW")).then(() => parcelRequire('7Ud5x'));